import { Badge, type BadgeProps } from '@mantine/core';
import { JobHistoryStatus } from '@/common/graphql';
import { JobHistoryStatusLabels } from '@/common/types';
import { MaterialIcons } from '../material-icons';

const JobHistoryStatusIcons: Record<JobHistoryStatus, string> = {
  [JobHistoryStatus.Current]: 'adjust',
  [JobHistoryStatus.Future]: 'alarm',
  [JobHistoryStatus.Past]: 'history',
};

const getStatusColor = (status: JobHistoryStatus) => {
  switch (status) {
    case JobHistoryStatus.Current:
      return 'blue';
    case JobHistoryStatus.Future:
      return 'yellow';
    case JobHistoryStatus.Past:
      return 'gray';
    default:
      return 'gray';
  }
};

interface Props extends BadgeProps {
  status: JobHistoryStatus;
}

export const JobHistoryStatusBadge = ({ status, ...rest }: Props) => (
  <Badge
    {...rest}
    classNames={{ label: 'size-4' }}
    color={getStatusColor(status)}
    title={JobHistoryStatusLabels[status]}
  >
    <MaterialIcons iconName={JobHistoryStatusIcons[status]} />
  </Badge>
);
